import { render, staticRenderFns } from "./CustomSelector.vue?vue&type=template&id=5cde44aa&scoped=true&"
import script from "./CustomSelector.vue?vue&type=script&lang=js&"
export * from "./CustomSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelector.vue?vue&type=style&index=0&id=5cde44aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cde44aa",
  null
  
)

export default component.exports